import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useRef, useState } from 'react';
import { Box, Grid, TAGSvgIcon } from '../../';
import RichText from './RichText'; // TODO: on contentful: add note to contentful model: Add "[facilityName]" as placeholder for facility name, and "[neighboringAreas]" as placeholder for neighbouring areas.

var TextBlockSEO = function TextBlockSEO(_ref) {
  var branding = _ref.branding,
      content = _ref.content,
      facilityData = _ref.facilityData;
  var dynamicFacilities = content === null || content === void 0 ? void 0 : content.raw.replace(/\[facilityName\]/gi, facilityData === null || facilityData === void 0 ? void 0 : facilityData.name).replace(/\[neighboringAreas\]/gi, facilityData === null || facilityData === void 0 ? void 0 : facilityData.neighboringAreas);

  var newContent = _objectSpread(_objectSpread({}, content), {}, {
    raw: dynamicFacilities
  });

  if (branding == 'mottoV2') {
    var _section$current;

    var section = useRef(null);

    var _useState = useState(0),
        _useState2 = _slicedToArray(_useState, 2),
        divHeight = _useState2[0],
        setDivHeight = _useState2[1];

    var _useState3 = useState({
      height: '130px',
      webkitMaskImage: 'linear-gradient(to bottom, black 15%, transparent 100%)',
      maskImage: 'linear-gradient(to bottom, black 15%, transparent 100%)',
      overflowY: 'hide',
      display: 'inline-block'
    }),
        _useState4 = _slicedToArray(_useState3, 2),
        style = _useState4[0],
        setStyle = _useState4[1];

    useEffect(function () {
      setDivHeight(section.current.scrollHeight);
      console.log(divHeight);
    }, [(_section$current = section.current) === null || _section$current === void 0 ? void 0 : _section$current.scrollHeight]);
    return React.createElement(Grid, {
      container: true,
      justifyContent: "center"
    }, React.createElement(Grid, {
      container: true,
      direction: 'column',
      alignItems: 'center'
    }, React.createElement(Box, {
      ref: section,
      sx: {
        height: style.height,
        overflow: 'hidden',
        transition: 'all 0.3s ease',
        maxWidth: {
          xs: '254px',
          md: '640px'
        },
        width: '100%',
        '& div': {
          webkitMaskImage: divHeight <= 130 ? 'none' : style.webkitMaskImage,
          maskImage: divHeight <= 130 ? 'none' : style.maskImage,
          overflowY: divHeight <= 130 ? 'none' : style.overflowY
        },
        '& span': {
          fontFamily: 'EBGaramond',
          fontStyle: 'normal',
          fontWeight: '400',
          fontSize: '15px',
          lineHeight: '27px',
          letterSpacing: '-0.01em'
        }
      }
    }, React.createElement(RichText, {
      branding: branding,
      content: newContent,
      backgroundColor: 'transparent',
      centerAlign: true
    })), React.createElement(Box, {
      sx: {
        cursor: 'pointer',
        display: divHeight <= 130 ? 'none' : style.display,
        pt: '20px'
      }
    }, React.createElement(TAGSvgIcon, {
      width: 38,
      height: 20,
      viewBox: '0 0 38 20',
      icon: "ShowMoreArrowDown",
      onClick: function onClick() {
        return setStyle({
          height: '100%',
          display: 'none',
          overflowY: 'auto',
          maskImage: 'none',
          webkitMaskImage: 'none'
        });
      }
    }))));
  }

  return React.createElement(Box, {
    sx: {
      '& span': {
        fontFamily: 'MessinaSansBook',
        fontWeight: '350',
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0px'
      }
    }
  }, React.createElement(RichText, {
    branding: branding,
    content: newContent,
    backgroundColor: 'transparent',
    centerAlign: false
  }));
};

export default TextBlockSEO;